<template>
  <div class="vn-news">
    <div class="banner mb-3">
      <img src="@/assets/banner/bidv2.jpg">
    </div>
    <div class="vn-news-title mb-2">
      <strong>TIN CÙNG CHUYÊN MỤC</strong>
    </div>
    <ul>
      <li>
        <span><a href="#" target="_blank">Buộc TikTok gỡ bỏ 100% các nội dung vi phạm pháp luật Việt Nam</a></span>
      </li>
      <li>
        <span><a href="#" target="_blank">Hãng xe Thành Bưởi xin lùi ngày kiểm tra, Sở GTVT TPHCM nói gì?</a></span>
      </li>
      <li>
        <span><a href="#" target="_blank">Người trúng đấu giá biển số 51K-888.88 hơn 32 tỷ đã liên hệ với Cục CSGT</a></span>
      </li>
      <li>
        <span><a href="#" target="_blank">Vì sao SIM 'rác' chặt đầu này lại mọc ra đầu khác?</a></span>
      </li>
      <li>
        <span><a href="#" target="_blank">Thị trường ô tô Việt Nam tụt hạng, vì sao?</a></span>
      </li>
      <li>
        <span><a href="#" target="_blank">Hết hôm nay, 'đại gia' Thanh Hoá không nộp tiền sẽ đấu giá lại biển số 51K-888.88</a></span>
      </li>
      <li>
        <span><a href="#" target="_blank">Chủ cửa hàng nói gì trước tin đồn iPhone 15 đội giá hàng triệu đồng do khan hàng?</a></span>
      </li>
      <li>
        <span><a href="#" target="_blank">Biển "thần tài" 51K-779.79 được mua giá 930 triệu đồng, biển 99A-666.99 giá 1,5 tỉ đồng</a></span>
      </li>
      <li>
        <span><a href="#" target="_blank">Amazon đầu tư 4 tỷ USD vào một startup AI</a></span>
      </li>
      <li>
        <span><a href="#" target="_blank">Người trúng đấu giá hơn 32 tỉ đồng cho biển số xe 51K-888.88 vẫn "bặt vô âm tín"</a></span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'VnNews'
}
</script>
<style lang="scss" scoped>
.vn-news {
  .vn-news-title {
    border-bottom: 3px double #1568b2;
  }

  .banner {
    img {
      width: 100%;
    }
  }

  ul {
    padding: 0;

    li {
      padding: 5px 0;
      margin: 0;
      list-style: none;
      display: flex;
      justify-content: space-between;
      font-size: 90%;
      border-bottom: 1px dotted #999999;

      a {
        color: #666666;
        white-space-collapse: collapse;
        text-wrap: nowrap;
        display: block;
        width: 500px;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      a:hover {
        color: #1568b2;
      }

      .news-date {
        font-size: 90%;
        margin-left: 10px;
      }

      .badge {
        font-weight: normal;
        padding: 2px 12px;
        border-radius: 8px;
      }
    }
  }
}
</style>
